module.exports = __webpack_public_path__ + "static/img/orderbgc.4e70b814.png";